import React from "react";
import { BackgroundImage, HeaderComponent } from "../../FifthComponents";
import { rehabilitationData } from "../../fifthUtils/constant";

const Rehabilitation = (props) => {
    const { selectedLanguage, language } = props;
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div>
            <BackgroundImage screenName={selectedLanguage?.txt_rehabilitation} classForBg='fifth-des-rehabilitation-bg' {...props} />
            <HeaderComponent title={selectedLanguage?.txt_rehabilitation} lineClass='bg-gray' titleClass='color-blue' />
            <div className="fifth-des-latest-news fifth-des-about fifth-des-rehabilitation-main">
                {rehabilitationData?.map((v, i) => {
                    return (
                        <div key={i}>
                            <div className="fifth-des-latest-news-img-div">
                                <img src={v?.img} alt="" />
                                <div className="fifth-des-latest-news-img-overlap">
                                    <h3>
                                        {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                                    </h3>
                                </div>
                            </div>
                            <div className="fifth-des-latest-news-text-div fifth-des-about-text-div">
                                <h2>
                                    {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                                </h2>
                                <p>
                                    {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                </p>
                                <button>
                                    {selectedLanguage?.read_more_button}
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}
export default Rehabilitation